'use client'

import { useCacheManagement } from '@/hooks/useCacheManagement'

/**
 * 缓存管理组件
 * 负责在应用启动时检查版本更新并管理缓存
 */
export function CacheManager() {
  // 初始化缓存管理
  useCacheManagement()

  // 这个组件不渲染任何UI，只负责缓存管理逻辑
  return null
}